import React, {Component} from 'react';
import './detail.scss';
import $ from 'jquery';
import classNames from 'classnames';
import API from './../../config/api';
import {connect} from 'react-redux';
import {refresh_admin} from './../../redux/models/admin';
import Header from "../../components/Header/header";
import {Toast} from 'antd-mobile';
import AppBtn from "../../components/AppBtn/appBtn";
import TopBtn from "../../components/TopBtn/topBtn";
import Live from "./Live";
import Comment from "./Comment";

const DETAIL_TYPE = {
  PICTEXT: 'PICTEXT',
  VIDEO: 'VIDEO',
  SWIPER: 'SWIPER'
}

@connect(
  state => ({admin: state.admin}),
  {refresh_admin}
)

class Detail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uuid: '',
      data: {},
      type: DETAIL_TYPE.PICTEXT,
      curSwiperText: '',
      curSwiperIndex: 1,
      name: '',
      camera: [], //非主镜头的数据
      isVideo: true, //顶部是否是直播或者视频
      img_url: '',
      mainCamera: {},//主镜头数据
      livePage: 1, //直播列表页数
      liveData: [], //直播列表数据
      commentPage: 1, //评论列表页数
      commentData: [], //评论列表
      activeNum: 1,  //tab
      isShowDesc: false,
      isLive: true,
      zhifb: false,
      isPc: true
    };

  }

  componentWillMount() {
    // this.getContentId();
    // this.statistics();
  }

  componentDidMount() {
    const {uuid, type,videoType} = this.props.match.params;
    const _hostname = window.location.hostname;
    if(uuid && type / 1 !== 3 && videoType / 1 !== 6   ){
      if (_hostname === 'cdn.bjnews.com.cn') {  //目前只有正式环境跳转他们H5
        window.location.href = `https://m.bjnews.com.cn/detail/${uuid}.html`;
      } else {
        this.handleConfig()
      }
    } else {
      this.handleConfig()
    }
    this._isZhiFuBao()
    this._isPc()
  }
// 判断是不在支付宝中
_isZhiFuBao = () => {
  if (/AlipayClient/.test(window.navigator.userAgent)) {
    this.setState({
      zhifb: true
    })
  } 
};

//判断是否是pc
_isPc = () => {
  if (!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
    this.setState({
      isPc: false
    })
  }
}

  handleConfig = () => {
    this.getContentId();
    this.statistics();
    this.initSwiper();
    this.videoSwiper = new window.Swiper('.video-swiper-container', {
      direction: 'horizontal', //横向切换选项
      loop: false, //循环模式选项
      slidesPerView: 'auto',
      initialSlide: 0,
      touchMoveStopPropagation: true,
      preventClicksPropagation: true,
      freeMode: false,
    })
    var _this = this
    $('.close').bind('click', function () {
      $('.video-container').css({
        top: 0
      })
    })
    $(window).scroll(function () {
      // const header = $('.header-box')[0] //判断顶部是否关闭
      const headerHeight = $('.header-box').height()  //顶部高度
      if ($(window).scrollTop() > 0) {
        $('.video-container').css({
          top: 0
        })
      } else {
        $('.video-container').css({
          top: headerHeight
        })
      }
      const videoMain = $('.video-main').height()
      const videoContainer = $('.video-container').height()
      if ($(window).scrollTop() >= videoMain) {
        $('.all_header').css({
          position: 'fixed',
          top: videoContainer,
          left: 0,
          marginTop: 0,
          zIndex: 999
        })
      } else {
        $('.all_header').css({
          position: 'relative',
          top: 0,
          left: 0,
          marginTop: '.12rem'
        })
      }
      const height = Math.round($(window).scrollTop()) == $(document).height() - $(window).height()
      if (height) {
        const {liveComment} = _this.state
        if (liveComment === 1) {
          _this.scrollBottom()
        } else if (liveComment === 2) {
          _this.scrollComment()
        } else {
          const {activeNum} = _this.state
          if (activeNum === 1) {
            _this.scrollBottom()
          } else {
            _this.scrollComment()
          }
        }
      }
    })
  }

  componentWillUnmount() {
    clearInterval(this.sendInterval)
    $('.close').unbind('click')
  }

  setDesc = (type) => {
    if (type === 1) {
      this.setState({descType: true})
    } else if (type === 2) {
      this.setState({descType: false})
    }
  }

  //获取非主镜头的镜头数
  getCameraNum = (data) => {
    const {camera} = this.state
    let num = 0
    camera.forEach((item, index) => {
      if (data === item) {
        num = index + 1
        return
      }
    })
    return num
  }

  //换算时分秒
  changeTime = (time) => {
    let h = 0, i = 0, s = parseInt(time, 0)
    if (s > 60) {
      i = parseInt(s / 60, 0)
      s = parseInt(s % 60, 0)
    }
    if (i > 60) {
      h = parseInt(i / 60, 0)
      i = parseInt(i % 60, 0)
    }
    // 补零
    var zero = function (v) {
      return (v >> 0) < 10 ? "0" + v : v;
    }
    if (h === 0) {
      return [zero(i), zero(s)].join(':')
    } else {
      return [zero(h), zero(i), zero(s)].join(':')
    }
  }

  //点击下面的分镜头
  clickCamera = (item, index) => {
    const {data, mainCamera} = this.state
    if (mainCamera.is_master / 1 === 1) {
      data.camera_lens.splice(index, 1)
      data.camera_lens.unshift(mainCamera)
    } else {
      data.camera_lens[index] = mainCamera
    }
    if (item.type / 1 !== 3) {
      this.setState({
        isVideo: true,
        data,
        mainCamera: item
      }, () => {
        this.playVideo(item.video_url)
      })
    } else {
      this.setState({
        isVideo: false,
        data,
        mainCamera: item,
        img_url: item.image_url
      })
    }
  }

  //获取直播列表
  getLiveList = () => {
    const {livePage, uuid} = this.state
    $.ajax({
      url: API.live_group,
      dataType: 'json',
      type: 'GET',
      data: {
        uuid: uuid,
        page: livePage
      }
    }).done((res) => {
      if (res.code === 0) {
        const {liveData} = this.state
        let page = livePage
        if (res.data.length > 0) {
          res.data.forEach((item, index) => {
            liveData.push(item)
          })
        } else {
          page--
        }
        this.setState({liveData, livePage: page})
      } else {
        Toast.fail(res.msg || res.error);
      }
    }).fail(() => {
      Toast.fail('内部服务器错误！');
    })
  }

  //获取评论列表
  getCommentList = () => {
    const {commentPage, uuid} = this.state
    $.ajax({
      url: API.comment_list,
      dataType: 'json',
      type: 'GET',
      data: {
        uuid: uuid,
        page: commentPage,
        is_show_reply: 1   //是否返回评论的回复，1表示是，0表示否
      }
    }).done((res) => {
      if (res.code === 0) {
        const {commentData} = this.state
        let page = commentPage
        if (res.data.length > 0) {
          res.data.forEach((item, index) => {
            commentData.push(item)
          })
        } else {
          page--
        }
        this.setState({commentData, commentPage: page})
      } else {
        Toast.fail(res.msg || res.error);
      }
    }).fail(() => {
      Toast.fail('内部服务器错误！');
    })
  }

  //图文直播滑动到最底部
  scrollBottom = () => {
    const {livePage} = this.state
    this.setState({
      livePage: livePage + 1
    }, () => {
      this.getLiveList()
    })
  }

  //评论留言滑动到底部
  scrollComment = () => {
    const {commentPage} = this.state
    this.setState({
      commentPage: commentPage + 1
    }, () => {
      this.getCommentList()
    })
  }

  setLiveDesc = (type, index) => {
    const {liveData} = this.state
    if (type === 1) {
      liveData[index].descType = true
      this.setState({liveData})
    } else if (type === 2) {
      liveData[index].descType = false
      this.setState({liveData})
    }
  }

  //切换tab
  changeTab = (value) => {
    const {activeNum} = this.state
    if (activeNum === value) {
      return
    }
    this.setState({activeNum: value})
  }

  //点击收起icon
  clickIcon = () => {
    const {isShowDesc} = this.state
    if (isShowDesc) {
      $('.title-rightIcon').removeClass('right_downIcon')
      this.setState({isShowDesc: false})
    } else {
      $('.title-rightIcon').addClass('right_downIcon')
      this.setState({isShowDesc: true})
    }
  }
  
  getHtml() {
    const {data, type, curSwiperIndex, isVideo, img_url, name, liveComment, activeNum, isShowDesc} = this.state;

    switch (type) {
      case DETAIL_TYPE.PICTEXT:
        return (
          <div className="picText-box">
            {/*题目*/}
            <div className="title" style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              'WebkitLineClamp': '2',
              'WebkitBoxOrient': 'vertical',
            }}>{data.title}
            </div>

            {/*其他信息*/}
            <div className="info-box">
              <div className="left">
                <div>{data.head_author}</div>
                {/*<div className="author-name">编辑 {data.author_name}</div>*/}
              </div>
              <div className="right">
                <div className="publish_time">{data.publish_time}</div>
              </div>
            </div>
            {/*概述*/}
            {data.desc ?
              <div className="desc">{data.desc}</div> : ''}

            {/*正文*/}
            <div className="main-text"
                 dangerouslySetInnerHTML={{__html: this.replacRem(data.content)}}></div>
            {/* 投票区 */}
            {data.ballot_info ?
              <div className="voteBox">
                <p className="voteTitle">{"< 投票专区 >"}</p>
                <ul className="voteLists">
                  {data.ballot_info.question_list.map((item, index) => {
                    return <li className="votelist" key={index}>
                      <p
                        className="voteList_title">{'问题' + (index + 1) + '：' + item.q_title + '(' + (item.select_num / 1 === 1 ? '单选' : '多选') + ')'}</p>
                      <ul className="optionsBox">
                        {item.option_list.map((childItem, childIndex) => {
                          return <li className="options" key={childIndex}>
                            {item.has_image / 1 === 1 ?
                              <div className="noImg_btn">{childItem.title}</div>
                              :
                              <div className="option">
                                <img src={childItem.image} alt={childItem.title}/>
                                <p className="option_title">{childItem.title}</p>
                                <button className="ballot_btn">投票</button>
                              </div>
                            }
                          </li>
                        })}
                      </ul>
                      <div className="clear"></div>
                    </li>
                  })}
                </ul>
              </div> : ''
            }

          </div>
        )
        break
      case DETAIL_TYPE.VIDEO:
        return (
          name === 'live' ?
            <div className="video-box">
              <div className="video-container" style={{top:this.state.zhifb?'1.7rem':'1rem'}}>
                {this.state.isLive ?   //正在直播
                  isVideo ?
                    <video
                      className={classNames("video")}
                      ref="video"
                      id="video"
                      controls
                      playsInline="true"
                      webkit-playsinline="true"
                      x5-playsinline="true"
                      poster={data.cover}>
                      <source id="videoSource" ref="videoSource" src=""></source>
                    </video> :
                    <img src={img_url} alt="图片"/>
                  :
                  <div className="yuyueBox">
                    <img src={data.cover} alt="封面"/>
                    <p className="yuyueTitle">{data.title}<br/>{data.trailer.start_time || ''}</p>
                  </div>
                }
              </div>
              <div className="video-main">
                <div className="video-title">
                  <div className="video-title-content" onClick={this.clickIcon}>{data.title}</div>
                  <div className="title-rightIcon" onClick={this.clickIcon}></div>
                </div>
                <div className="video-authors">{data.head_author}
                  <span style={{marginLeft: '.2rem'}}>{data.publish_time}</span>
                </div>
                {isShowDesc ?
                  <div className="video-des">
                    {data.desc}</div> : ''
                }
                {/*<div className="dividingLine"></div>*/}
                {data.camera_lens.length > 0 ?
                  <div className="video-swiper-container">
                    <div className="swiper-wrapper">
                      {data.camera_lens.length > 0 ? data.camera_lens.map((item, index) => {
                        return <div className="swiper-slide"
                                    onClick={this.clickCamera.bind(this, item, index)}
                                    key={index}>
                          <div className="swiper-video-cover">
                            <img src={item.image_url} alt="封面图"/>
                            {item.type / 1 !== 3 ?  //非图片
                              <div className="swiper-video-play">
                                <span className={item.type / 1 === 1 ? 'live_icon' : 'video_icon'}></span>
                                {item.type / 1 === 1 ?
                                  <span>{item.is_master / 1 === 1 ? '直播' : '镜头' + this.getCameraNum(item)}</span> :
                                  <span>{this.changeTime(item.duration)}</span>
                                }
                              </div> : ''
                            }
                          </div>
                          <div className="swiper-video-title">{item.desc}</div>
                        </div>
                      }) : ''}
                    </div>
                  </div> : ''
                }
              </div>
              {liveComment === 0 ?  //既没有图文直播也没有评论区
                '' :
                liveComment === 1 ? //只有图文直播
                  <div>
                    <div className="live_header">图文直播</div>
                    <Live liveData={this.state.liveData}
                          setLiveDesc={this.setLiveDesc}
                    />
                  </div> :
                  liveComment === 2 ? //只有评论
                    <div>
                      <div className="live_header">直播留言</div>
                      <Comment commentData={this.state.commentData}
                      />
                    </div> :
                    liveComment === 3 ? //既有图文直播也有评论区
                      <div>
                        <div className="live_header all_header">
                          <div className={
                            activeNum === 1 ?
                              "live_title title_active" : "live_title"}
                               onClick={this.changeTab.bind(this, 1)}>
                            图文直播
                            {activeNum === 1 ?
                              <div className="tabBottom"></div> : ''
                            }
                          </div>
                          <div className={
                            activeNum === 2 ?
                              "comment_title title_active" : "comment_title"}
                               onClick={this.changeTab.bind(this, 2)}
                          >
                            直播留言
                            {activeNum === 2 ?
                              <div className="tabBottom"></div> : ''
                            }
                          </div>
                        </div>
                        {activeNum === 1 ? //图文直播
                          <Live liveData={this.state.liveData}
                                setLiveDesc={this.setLiveDesc}
                          /> :
                          <Comment commentData={this.state.commentData}
                          />
                        }
                      </div> : ''
              }
            </div> :
            <div className="videoBox">
              <div className="videoContainer">
                <video
                  className={classNames("video")}
                  ref="video"
                  id="video"
                  controls
                  playsinline="true"
                  webkit-playsinline="true"
                  x5-playsinline="true"
                  poster={data.cover}>
                  <source id="videoSource" ref="videoSource" src=""></source>
                </video>
              </div>
              <div className="videoTitle">{data.title}</div>
              <div className="videoDes" style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                'WebkitLineClamp': '2',
                'WebkitBoxOrient': 'vertical',
              }}>{data.desc}</div>
            </div>
        )
        break;
      case DETAIL_TYPE.SWIPER:
        return (
          <div className="sicSwiper-box">
            {
              data.desc ? (
                <div className="sicSwiper-title" style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  'WebkitLineClamp': '2',
                  'WebkitBoxOrient': 'vertical',
                }}>{data.desc}</div>
              ) : ('')
            }
            <div className="sicSwiper-container" id="subject_swiper">
              <div className="swiper-wrapper" id="subject_list">
                {
                  data.content.map((item, index) => {
                    // var suffix = Tool.getSuffix(item.cover, 500)
                    return (
                      <div className="swiper-slide" style={{
                        backgroundImage: 'url(' + item.image_url + ')'
                      }} key={index}></div>
                    )
                  })
                }
              </div>
              {/*前进后退*/}
              <div className="swiper-button-prev"></div>
              <div className="swiper-button-next"></div>
            </div>
            <div className="sicSwiper-info">
              <div className="sicSwiper-num">{curSwiperIndex + 1 + '/' + data.content.length}</div>
            </div>
            <div className="sicSwiper-content">{data.content[curSwiperIndex]?data.content[curSwiperIndex].desc:''}</div>
          </div>
        )
        break;
        default: ''
    }
  }

  render() {
    const {data, type, name, zhifb} = this.state;

    return (
      <div className="detail-box">

        {/*头部*/}
        <Header name={name} uuid={this.state.uuid}/>

        {this.getHtml()}

        {/*打开APP按钮*/}
        {zhifb ? '' : <AppBtn name={name}
                uuid={this.state.uuid}
                text={data.ballot_info ? "打开新京报App，参与活动投票" : data.type / 1 === 6 && data.live_status / 1 === 3 ? "打开新京报APP，预约观看直播" : "打开新京报App，阅读体验更佳"}/>}

        {/*评论*/}
        {
          type === DETAIL_TYPE.SWIPER || ((type === DETAIL_TYPE.VIDEO && name === 'video') && (data.is_open_graph_text / 1 === 0 || data.is_open_comment_area / 1 === 0)) ? ('') : (
            data.hasOwnProperty('comment_list') && (data.comment_list && data.comment_list.hot_comment.length !== 0) ? (
              <div>
                <div className="comment-box">
                  <div className="comment-title">热门评论</div>
                  <div className="comment-list">
                    {
                      data.hasOwnProperty('comment_list') ? (data.comment_list.hot_comment.map((item, index) => {
                        return (
                          <div className="comment-item" key={index}>
                            <div className="left">
                              <div className="head-img" style={{
                                backgroundImage: 'url(' + item.head_image + ')'
                              }}></div>
                            </div>
                            <div className="right">
                              <div className="name">{item.user_name}</div>
                              <div className="time">{item.add_time}</div>
                              <div className="content">{item.content}</div>
                            </div>
                          </div>
                        )
                      })) : ('')
                    }
                  </div>
                </div>
                {/*打开APP按钮*/}
                {/*<AppBtn style={{*/}
                {/*marginTop: '.35rem'*/}
                {/*}} text="打开新京报App，参与评论"/>*/}
              </div>
            ) : ('')

          )
        }


        <TopBtn type={1}/>

      </div>
    );
  }

  ymstatistics() {
    setTimeout(() => {
      if (window._czc) {
        let location = window.location
        let contentUrl = location.pathname + location.hash
        let refererUrl = '/'
        window._czc.push(['_trackPageview', contentUrl], refererUrl)
      } else {
        // console.log('_czc null')
      }
    }, 2000)
  }

  getContentId() {
    const {uuid, type} = this.props.match.params;
    if (uuid && type) {
      this.state.uuid = uuid
      switch (parseInt(type)) {
        case 1:             //图文
          this.setState({
            type: DETAIL_TYPE.PICTEXT,
            name: 'article'
          })
          this.getContent()
          break;
        case 2:             //视频
          this.setState({
            type: DETAIL_TYPE.VIDEO
          })
          this.getVideoContent()
          break;
        case 3:
          this.setState({    //图说
            type: DETAIL_TYPE.SWIPER,
            name: 'imageSays'
          })
          this.getSwiperContent()
          break;
          default:''
      }
    } else {
      this.props.history.push('/');
      return
    }
  }

  getContent() {
    $.ajax({
      type: 'get',
      url: API.anuscript_detail,
      async: false,
      headers: {
        version: 'v103'
      },
      data: {
        uuid: this.state.uuid,
      },
      dataType: 'json'
    }).done((res) => {
      if (res.code == 0 || res.errorCode == 0) {
        this.setState({
          data: res.data
        }, () => {
          if (this.state.type === DETAIL_TYPE.VIDEO) {
            this.playVideo(res.data.ext_data.video_url)
          }
          this.replaceHref()
          document.title = res.data.title;
          this.initWx({
            title: res.data.title,
            desc: res.data.desc,
          })
        })
      } else {
        Toast.fail(res.msg || res.error);
        return
      }
    });
  }

  getVideoContent() {
    const {videoType} = this.props.match.params;
    if (!videoType) {
      this.props.history.push('/');
      return
    }
    if (videoType / 1 === 2) { //视频
      this.setState({
        name: 'video'
      })
    } else if (videoType / 1 === 6) {  //直播
      this.setState({
        name: 'live'
      })
      this.connectWesocket()
    }
    $.ajax({
      type: 'get',
      url: API.video_detail,
      async: false,
      data: {
        uuid: this.state.uuid,
        type: videoType,
      },
      dataType: 'json'
    }).done((res) => {
      if (res.code == 0 || res.errorCode == 0) {
        this.setState({
          data: res.data
        }, () => {
          const {camera, data} = this.state
          if (videoType / 1 === 2 || (videoType / 1 === 6 && data.live_status / 1 !== 3)) {
            this.playVideo(res.data.ext_data.video_url)
          }
          this.replaceHref()
          if (videoType / 1 === 6) {  //直播
            let isLive = true

            if(!this.state.isPc){
              window.location.href = `https://www.bjnews.com.cn/detail/${res.data.uuid}.html`
            }

            if (data.live_status / 1 === 3) {
              isLive = false
            }
            const mainCamera = {
              is_master: 1,
              type: 1,
              video_url: data.ext_data.video_url,
              image_url: data.cover,
              desc: data.title
            }  //主镜头信息
            this.state.data.camera_lens.forEach((item, index) => {
              if (item.is_master / 1 === 0 && item.type / 1 === 1) {   //非主镜头
                camera.push(item)
              }
            })
            let liveComment = 0
            if (data.is_open_graph_text / 1 === 0 && data.is_open_comment_area / 1 === 0) {
              // 既没有图文直播也没有评论区
              liveComment = 0
            } else if (data.is_open_graph_text / 1 === 1 && data.is_open_comment_area / 1 === 0) {
              //只有图文直播
              liveComment = 1
              this.getLiveList()
            } else if (data.is_open_graph_text / 1 === 0 && data.is_open_comment_area / 1 === 1) {
              //只有评论区
              liveComment = 2
              this.getCommentList()
            } else if (data.is_open_graph_text / 1 === 1 && data.is_open_comment_area / 1 === 1) {
              //图文直播评论区都有
              liveComment = 3
              this.getLiveList()
              this.getCommentList()
            }
            this.setState({camera, mainCamera, liveComment, isLive})
          }

          if (videoType / 1 === 6 && res.data.live_status / 1 === 1) { //直播中
            document.title = '正在直播！' + res.data.title;
          } else {
            document.title = res.data.title;
          }

          this.initWx({
            title: videoType / 1 === 6 && res.data.live_status / 1 === 1 ? '直播：' + res.data.title : res.data.title,
            desc: res.data.desc,
          })
        })
      } else {
        Toast.fail(res.msg || res.error);
        return
      }
    });
  }

  getSwiperContent() {
    $.ajax({
      type: 'get',
      url: API.graph_article_detail,
      async: false,
      data: {
        uuid: this.state.uuid,
      },
      dataType: 'json'
    }).done((res) => {
      if (res.code == 0 || res.errorCode == 0) {
        this.setState({
          data: res.data
        }, () => {
          this.replaceHref()
          var cur = res.data.content[0];
          var cur_w = parseFloat(cur.width);
          var cur_h = parseFloat(cur.height);
          var h = cur_h / cur_w * 7.5
          $('#subject_swiper').css({
            height: h + 'rem'
          })
          document.title = res.data.title;

          this.initWx({
            title: res.data.title,
            desc: res.data.desc,
          })
        })
      } else {
        Toast.fail(res.msg || res.error);
        // this.props.history.push('/');
        return
      }
    });
  }


  playVideo(url) {
    var _this = this
    this.refs.videoSource.src = url;
    this.refs.video.load();
    setTimeout(() => {
      _this.refs.video.play();
      document.addEventListener("WeixinJSBridgeReady", function () {
        _this.refs.video.play();
      }, false);
    }, 1000)
  }

  initSwiper() {
    var _this = this;
    this.subject_swiper = new window.Swiper('#subject_swiper', {
      direction: 'horizontal',
      loop: true,
      initialSlide: 0,
      touchMoveStopPropagation: true,
      preventClicksPropagation: true,
      slidesPerView: 'auto',
      freeMode: false,

      // 如果需要分页器
      pagination: {
        el: '.swiper-pagination',
      },

      // 如果需要前进后退按钮
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // 如果需要滚动条
      scrollbar: {
        el: '.swiper-scrollbar',
      },

      on: {
        slideChangeTransitionEnd: function () {
          _this.setState({
            curSwiperIndex: this.realIndex//切换结束时，告诉我现在是第几个slide
          })
          var cur = _this.state.data.content[this.realIndex];
          var cur_w = parseFloat(cur.width);
          var cur_h = parseFloat(cur.height);
          var h = cur_h / cur_w * 7.5
          $('#subject_swiper').css({
            height: h + 'rem'
          })
        },
      },
    })
  }


  replaceHref() {
    for (var i = 0; i < $('a').length; i++) {
      var href = $($('a')[i]).attr('href')
      if (href.indexOf('type=') > -1 && href.indexOf('uuid=') > -1) {
        //替换
        var array = href.split('&');
        var obj = {};
        for (var j = 0; j < array.length; j++) {
          var arr = array[j].split('=');
          obj[arr[0]] = arr[1]
        }
        var new_href = API.host + '/index.html#/';
        switch (obj.type) {
          case 'article':
            new_href += 'detail/1/' + obj.uuid;
            break;
          case 'video':
            new_href += 'detail/2/' + obj.uuid + '/2';
            break;
          case 'live':
            new_href += 'detail/2/' + obj.uuid + '/6';
            break;
          case 'imageSays':
            new_href += 'detail/3/' + obj.uuid;
            break;
          case 'normalSpecial':
            new_href += 'subject/1/' + obj.uuid;
            break;
          case 'timeLineSpecial':
            new_href += 'subject/2/' + obj.uuid;
            break;
          case 'newSpecial':
            new_href += 'newSubject' + obj.uuid;
            break;
            default:''
        }
        $($('a')[i]).attr('href', new_href)
      }
    }
  }

  replacRem(content) {
    for (var i = 10; i < 50; i++) {
      var px = i + 'px';
      var rem = i / 100 * 2 + 'rem'
      if(content){
        content = content.replace(new RegExp(px, 'g'), rem)
      }
      
    }
    return content
  }


  statistics(share) {
    var op = share ? 'share' : 'pv';
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = API.pv + '?xm=bjnews&wz=article_detail&op=' + op + '&pt=wap&unique_id=' + this.state.uuid;     //填自己的js路径
    $('body').append(script);
  }

  encodingBase64(val){
    let base64hash = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'

    //把字符串转换为字符数组
    let strArr = val.split('')

    //装入结果的数组
    let result = []
    //每个字符的ascii码
    let asciiCode
    //上一个字符的ascii码
    let prevAsciiCode

    let mod
    //未填充之前的数组与3的模
    let preMod = strArr.length % 3

    //使字符数组组成三个一组
    if(preMod == 1){
      strArr.push(null)
      strArr.push(null)
    }
    if(preMod == 2) strArr.push(null)
    //遍历整个数组，寻找每个字符的ascii码
    for(let index in strArr){
      if(!strArr[index]){
        asciiCode = 0
      }
      else{
        asciiCode = strArr[index].charCodeAt()
      }
      //位于一组当中的第几个字符
      mod = index % 3
      switch(mod){
        case 0:
          //往右移2位
          result.push(base64hash[asciiCode >> 2])
          break
        case 1:
          //上一个ascii码往左移4位与现在的ascii码往右移四位做或操作
          result.push(base64hash[(prevAsciiCode & 3) << 4 | asciiCode >> 4])
          break
        case 2:
          result.push(base64hash[(prevAsciiCode & 15) << 2 | asciiCode >> 6])
          result.push(base64hash[asciiCode & 63])
          break
        default:''
      }

      prevAsciiCode = asciiCode
    }

    //处理异常
    if(preMod == 1) {
      result.splice(result.length - 2,2)
      result.push('==')
    }
    else if(preMod == 2) {
      result.pop()
      result.push('=')
    }

    return result.join('')
  }

  initWx(obj) {
    const {data} = this.state
    const ori_cover = this.encodingBase64(data.cover) || ''
    let share_img = ''
    if (data.type / 1 === 2 || data.type / 1 === 6) {
      $.ajax({
        url: API.share_logo,
        dataType: 'json',
        type: 'GET',
        async : false, //同步
        data: {
          ori_cover: ori_cover,
          type: data.type,
          live_status: data.type / 1 === 6 ? data.live_status : ''
        }
      }).done((res)=>{
        if(res.code === 0){
          share_img = res.data.share_logo_url
        }
      })
    }
    //分享
    var wxconfig = new window.WxConfig();
    // console.log(window.location.href);
    wxconfig.init({
      appid: API.appid,
      url: window.location.href,
      title: obj.title,
      desc: obj.desc || API.share_des,
      link: window.location.href,
      imgUrl: share_img || API.share_img,
      successCallback: this.statistics.bind(this, true)
    });
  }

  //websocket连接
  connectWesocket = () => {
    var _this = this
    const _hostname = window.location.hostname;
    // console.log(_hostname)
    let ws_url = 'ws://60.205.221.251:8080'
    if (_hostname === 'cdn.bjnews.com.cn') {  //正式环境
      ws_url = 'wss://ws.bjnews.com.cn'
    }
    this.ws = new WebSocket(ws_url)
    const date = new Date().getTime()
    this.ws.onopen = function () {
      // console.log('websocket已打开')
      const msg = {
        cmd: 'ANCLL',
        p: 'bjnews_app',
        g: 'live',
        ak: 'cda13d79e18515b72b13327ef3c938f5',
        t: date,
        ass: 'jda13d79e18515b7jb13327ef3c93dfe',
        uuid: _this.state.uuid
      }
      _this.ws.send(JSON.stringify(msg))
      var ping = {cmd: 'ping'}
      _this.sendInterval = setInterval(function () {
        _this.ws.send(JSON.stringify(ping))
      }, 30000)
    }
    this.ws.onmessage = function (message) {
      const data = JSON.parse(message.data) || {}
      const msgData = data.data
      const cmd = data.cmd
      _this.updateList(msgData, cmd)
    }
    this.ws.close = function () {
      // console.log('websocket已关闭')
    }
  }

  //socket增删改查
  updateList = (data, cmd) => {
    const liveData = [...this.state.liveData]
    const commentData = [...this.state.commentData]
    if (cmd === 'addGraphText' || cmd === 'updateGraphText' || cmd === 'delGraphText' || cmd === 'topGraphText' || cmd === 'unTopGraphText') { //图文直播
      if (cmd === 'addGraphText') {  //新增图文
        data.forEach((item, index) => {
          liveData.unshift(item)  //头部插入
        })
      } else if (cmd === 'updateGraphText') {  //更新图文
        data.forEach((item, index) => {
          liveData.forEach((liveItem, liveIndex) => {
            if (item.id / 1 === liveItem.id / 1) {
              liveData[liveIndex] = item
            } else {
              return
            }
          })
        })
      } else if (cmd === 'delGraphText') {  //删除图文
        data.forEach((item, index) => {
          liveData.forEach((liveItem, liveIndex) => {
            if (item.id / 1 === liveItem.id / 1) {
              liveData.splice(liveIndex, 1)
            }
          })
        })
      } else if (cmd === 'topGraphText') { //置顶图文
        data.forEach((item, index) => {
          liveData.forEach((liveItem, liveIndex) => {
            if (item.id / 1 === liveItem.id / 1) {
              liveData.splice(liveIndex, 1)
              liveData.unshift(item)
            }
          })
        })
      } else if (cmd === 'unTopGraphText') { //取消置顶图文
        data.forEach((item, index) => {
          liveData.forEach((liveItem, liveIndex) => {
            if (item.id / 1 === liveItem.id / 1) {
              const topItem = {...liveItem}
              liveData.splice(liveIndex, 1)
              for (let i = 0; i < liveData.length; i++) {
                if (liveData[i].is_top / 1 === 0) {  //从非置顶的评论插入
                  topItem.is_top = 0
                  liveData.splice(i, 0, topItem)
                  break
                }
              }
            }
          })
        })
      } else {
        return
      }
      this.setState({liveData})
    } else if (cmd === 'add_comment' || cmd === 'top_comment' || cmd === 'un_top_comment' || cmd === 'del_comment') {
      //评论留言
      if (cmd === 'add_comment') {  //新增评论
        data.forEach((item, index) => {
          if (item.at_user_name.length === 0) {  //是直接评论
            for (let i = 0; i < commentData.length; i++) {
              if (commentData[i].is_top / 1 === 0) {  //从非置顶的评论插入
                commentData.splice(i, 0, item)
                break
              }
            }
          } else {  //是回复评论
            commentData.forEach((commItem, commIndex) => {
              if (item.root_uuid / 1 === commItem.comm_uuid / 1) {
                commentData[commIndex].reply_list.pop() //删除最后一项
                commentData[commIndex].reply_list.unshift(item) //回复的头部插入
                commentData[commIndex].re_num = commentData[commIndex].re_num / 1 + 1
              }
            })
          }
        })
      } else if (cmd === 'top_comment') {  //置顶评论
        data.forEach((item, index) => {
          commentData.forEach((commItem, commIndex) => {
            if (item.comm_uuid / 1 === commItem.comm_uuid / 1) {
              commentData.splice(commIndex, 1)  //删除置顶之前的评论
              commentData.unshift(item)  //头部插入
            }
          })
        })
      } else if (cmd === 'un_top_comment') {  //取消置顶
        data.forEach((item, index) => {
          commentData.forEach((commItem, commIndex) => {
            if (item.comm_uuid / 1 === commItem.comm_uuid / 1) {
              const topItem = {...commItem}
              commentData.splice(commIndex, 1)
              for (let i = 0; i < commentData.length; i++) {
                if (commentData[i].is_top / 1 === 0) {  //从非置顶的评论插入
                  topItem.is_top = 0
                  commentData.splice(i, 0, topItem)
                  break
                }
              }
            }
          })
        })
      } else if (cmd === 'del_comment') { //删除评论
        data.forEach((item, index) => {
          if (item.root_uuid / 1 === 0) {  //是直接评论
            commentData.forEach((commItem, commIndex) => {
              if (item.comm_uuid / 1 === commItem.comm_uuid / 1) {
                commentData.splice(commIndex, 1)
              }
            })
          } else {  //是回复评论
            commentData.forEach((commItem, commIndex) => {
              if (item.root_uuid / 1 === commItem.comm_uuid / 1) {
                commItem.reply_list.forEach((replyItem, replyIndex) => {
                  if (item.comm_uuid / 1 === replyItem.comm_uuid / 1) {
                    commentData[commIndex].reply_list.splice(replyIndex, 1)
                    commentData[commIndex].re_num = commentData[commIndex].re_num / 1 - 1
                  }
                })
              }
            })
          }
        })
      } else {
        return
      }
      this.setState({commentData})
    } else {
      return
    }

  }
}

export default Detail;


// WEBPACK FOOTER //
// ./src/pages/Detail/detail.js